
        import 'AddPartner.88fb123.css-module'
        export default {"addPartner":"addPartner_AddPartner_88fb123"}
    